import React from 'react';

const Step = ({ num, title, desc }) => (
  <div className="relative">
    <div className="w-16 h-16 bg-retro-yellow border-4 border-retro-brown rounded-2xl flex items-center justify-center font-display text-4xl mb-6 shadow-retro-sm">
      {num}
    </div>
    <h3 className="font-display text-2xl uppercase mb-3">{title}</h3>
    <p className="font-body font-bold text-gray-600 leading-snug">{desc}</p>
  </div>
);

const Process = () => {
  return (
    <section className="py-24 border-b-4 border-retro-brown bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-20">
          <h2 className="font-display text-5xl md:text-7xl uppercase tracking-tighter">How It Works</h2>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          <Step num="01" title="Claim Your Category" desc="Lock out competitors and reserve your industry slot in the next edition." />
          <Step num="02" title="We Handle Everything" desc="Send your logo and details—we design, print, mail, and set up QR tracking." />
          <Step num="03" title="Hits 10,000 Homes" desc="Premium 9' x 12' guide delivered into West Valley homes—built to be kept." />
          <Step num="04" title="Build Recognition" desc="Become the trusted, recognized go-to in your category—before the need even hits." />
        </div>
      </div>
    </section>
  );
};

export default Process;